import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import {
  UpdateMyShopBillingMethod,
  GetBillingMethod,
  core_apimessages_CreditCard,
  core_apimessages_AdyenPaymentResult,
} from '../schemas/rql';

export interface BillingMethodResult {
  billingMethodUuid: string;
  creditCard: core_apimessages_CreditCard;
  adyenPaymentResult: core_apimessages_AdyenPaymentResult;
}

export const myShopBillingMethods = gql`
  fragment myShopBillingMethods on rql_Me {
    id
    shop {
      currency
      originCountryCode
      shopType
      billingMethodStatus
      paypalSetupStatus
      paypalProfile {
        email
      }
    }
    creditCards {
      id
      last4
      cardType
      expirationYear
      expirationMonth
      cardholderName
      primaryBilling
      address {
        postalCode
        countryCode
      }
    }
  }
`;

export const GET_BILLING_METHOD = gql`
  query GetBillingMethod {
    countries {
      countries {
        name
        countryCode
        subregions {
          name
          code
        }
      }
    }
    me {
      ...myShopBillingMethods
    }
  }
  ${myShopBillingMethods}
`;

export const connectGetBillingMethod = graphql<{}, GetBillingMethod.Query, GetBillingMethod.Variables>(
  GET_BILLING_METHOD,
  {
    options: {
      ssr: false,
    },
  },
);

export const UPDATE_MY_SHOP_BILLING_METHOD = gql`
  mutation UpdateMyShopBillingMethod($input: Input_core_apimessages_UpdateBillingMethodRequest) {
    updateMyShopBillingMethod(input: $input) {
      errors {
        message
      }
      creditCard {
        id
      }
      adyenPaymentResult {
        paymentStatus
        fingerprintToken
        challengeToken
        paymentData
        threeDsOneData {
          paReq
          md
          termUrl
          redirectUrl
        }
      }
      billingMethodUuid
      me {
        ...myShopBillingMethods
      }
    }
  }
  ${myShopBillingMethods}
`;

export const connectUpdateMyShopBillingMethod =
  graphql<{}, UpdateMyShopBillingMethod.Mutation, UpdateMyShopBillingMethod.Variables>(
    UPDATE_MY_SHOP_BILLING_METHOD,
    {
      name: 'updateMyShopBillingMethod',
    },
  );



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/billing/billing_method_operations.ts